/* jshint browser:true */

/**
 * Management for Google Translate components.
 */
export default class GoogleTranslate {
  /**
   * Initializes a Google Translate element if available.
   * @param {string} selector CSS selector to find element.
   */
  init(selector) {
    const wrapper = document.querySelector(selector);

    if (!wrapper) {
      return;
    }

    this.setup();
  }

  /**
   * Sets up an individual Google Translate element.
   */
  setup() {
    if (!window.rplGoogleTranslateLoaded) {
      // Set up global callback function
      window.rplGoogleTranslateInit = () => {
        new google.translate.TranslateElement(
          { pageLanguage: 'en' },
          'googleTranslateWrapper'
        );
      };

      // Add Google Translate script to page
      this.addScript();
      window.rplGoogleTranslateLoaded = true;
    } else {
      // Rerun callback
      this.resetScript();
    }
  }

  /**
   * Adds the Google Translate script to the HEAD element.
   */
  addScript() {
    const headEl = document.getElementsByTagName('head')[0];
    const scriptEl = document.createElement('script');

    scriptEl.src = 'https://translate.google.com/translate_a/element.js?cb=rplGoogleTranslateInit';

    headEl.appendChild(scriptEl);
  }

  /**
   * Removes the Google Translate scripts and style sheets.
   */
  removeScripts() {
    const els = document.querySelectorAll(
      'script[src^="https://translate.google"], link[href^="https://translate.google"]'
    );

    els.forEach(x => x.remove());
  }

  /**
   * Removes and re-adds the Google Translate script.
   */
  resetScript() {
    this.removeScripts();
    this.addScript();
  }
}
